import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import App from "./App";
import Modal from "react-modal";
import { HelmetProvider } from "react-helmet-async";

const container = document.getElementById("root");

Modal.setAppElement("#root");

const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}